const ContactGroupListColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    sorter: (a, b) => a.index - b.index,
    width: 100
  },
  {
    title: 'Contact Group',
    dataIndex: 'description',
    sorter: (a, b) => a.description.localeCompare(b.description),
    width: 300
  },
  {
    title: 'List of Contact',
    dataIndex: 'contacts',
    slot: 'contacts',
    width: 300
  },
  {
    title: '',
    dataIndex: '',
    slot: 'operation',
    width: 50
  }
];
export { ContactGroupListColumn };
